import { default as _91slug_93JFSD00WsxwMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue?macro=true";
import { default as _91slug_93O1WwknNVN3Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue?macro=true";
import { default as _91name_934UzcbxHbGAMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue?macro=true";
import { default as _91paxid_93L89MvoKpSNMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue?macro=true";
import { default as _91id_93lC7bve34X9Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/payment/[id].vue?macro=true";
import { default as _91id_93pOzk630tR1Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/omdome/[id].vue?macro=true";
import { default as _91tab_93eJkMdOJ96PMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue?macro=true";
import { default as _91tab_93NjnNEv0OJjMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue?macro=true";
import { default as _91tab_93TgcLkUp59OMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue?macro=true";
import { default as _91tab_937bTDmfCT02Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue?macro=true";
import { default as _91tab_93hFL7vAIRfbMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue?macro=true";
import { default as _91slug_930dB0hjD0PdMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/info/[slug].vue?macro=true";
import { default as _91id_93o8eGbhAqFkMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/fn/[id].vue?macro=true";
import { default as _91tab_93XtqzH90rnhMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue?macro=true";
import { default as _91slug_93wdVKEWYFNkMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/competition/[slug].vue?macro=true";
import { default as _91slug_93gGCPsybSEgMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue?macro=true";
import { default as _91ocr_93Gqkf88YJc4Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue?macro=true";
import { default as _91ocr_93ePc2pJ1mf3Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue?macro=true";
import { default as _91id_93eQmU5uUK6YMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue?macro=true";
import { default as _91tripid_93B6mSUac5jIMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue?macro=true";
import { default as _91step_93OuF5dCwtc4Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue?macro=true";
import { default as _91slug_93czLpm6xUZBMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue?macro=true";
import { default as _91jwt_93itElB67wbZMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue?macro=true";
import { default as _91tab_93mnd1IKlWSPMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue?macro=true";
import { default as indexEhuVPfzmfdMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/app/index.vue?macro=true";
import { default as callbackee7xuxVS5AMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue?macro=true";
import { default as blackweekY96t9OPyYjMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue?macro=true";
import { default as _91slug_937kPNnxXsqRMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue?macro=true";
import { default as indexWSD69A4fguMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue?macro=true";
import { default as bookcallJfW8bTuwWdMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue?macro=true";
import { default as byebyeieu567oBlBgVMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/byebyeie.vue?macro=true";
import { default as indexY9TIYXoorwMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue?macro=true";
import { default as lastminuteARVHhQl2mSMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue?macro=true";
import { default as _91name_93bLMfotTArEMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue?macro=true";
import { default as indexCr7v5mfcehMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue?macro=true";
import { default as catalogueSz9rf6kcZvMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue?macro=true";
import { default as complaintTTXdxlbZaAMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/complaint.vue?macro=true";
import { default as dinbokning_45aktuelltbiLKRd2gGMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue?macro=true";
import { default as _91slug_93aQmXvvry0WMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue?macro=true";
import { default as indexv1kh9KdJiJMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue?macro=true";
import { default as faqzIFcU0F2DdMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/faq.vue?macro=true";
import { default as _91id_93Q4hM6taDNuMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue?macro=true";
import { default as indexJac0MU2T8wMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/giftcard/index.vue?macro=true";
import { default as _91name_93vFeNP8EymdMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/hotels/[name].vue?macro=true";
import { default as indexIblmBZvcCVMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/hotels/index.vue?macro=true";
import { default as indexybA7mqGs8IMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue?macro=true";
import { default as grouptravelOsCvwVZLY8Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue?macro=true";
import { default as indexw3SlWmJ89AMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue?macro=true";
import { default as reviewsWDwNpmrYTYMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/reviews.vue?macro=true";
import { default as lastminutePnNJRk1tyAMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue?macro=true";
import { default as mapY2uhnD3OclMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue?macro=true";
import { default as dinbokningrUDpIOMbyrMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue?macro=true";
import { default as newsletterydlz5xXVEIMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/newsletter.vue?macro=true";
import { default as offlinelefXXyRPa5Meta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/offline.vue?macro=true";
import { default as failedH7VXqDpyAFMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/payment/failed.vue?macro=true";
import { default as indexpWuWs2taHMMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/review/index.vue?macro=true";
import { default as searchHZIXknhb9GMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/search.vue?macro=true";
import { default as indexNmBsjwHSqwMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/tourleader/index.vue?macro=true";
import { default as verification_45done4hNQU4E4vTMeta } from "/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/verification-done.vue?macro=true";
export default [
  {
    name: "tourleader-id",
    path: "/reiseleder/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "titinerary",
    path: "/reiseplan",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "shipinfo",
    path: "/cruiseskip",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "satisfactionstatus-triptypeid",
    path: "/tilfredshet-status/:triptypeid()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "omdome",
    path: "/omdome",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "mytrip",
    path: "/dinreise",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "info-solo",
    path: "/info/solo",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue")
  },
  {
    name: "info-lectures",
    path: "/info/forelesninger",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-connections",
    path: "/info/anslutning",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-about",
    path: "/info/om",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "fn",
    path: "/fn",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "destination-slug",
    path: "/destination/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "competition",
    path: "/konkurranse",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "category",
    path: "/kategori",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "bookingfaq",
    path: "/boknings-faq",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "booking-finish",
    path: "/booking-finish",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking-confirmation",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "bookflight",
    path: "/bookflight",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "book-tripid",
    path: "/bestill/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "auth",
    path: "/medlem",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "app-l",
    path: "/app/l",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "triptype-slug",
    path: "/:triptype()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "triptype-slug-tab",
    path: "/:triptype()/:slug()/:tab()",
    meta: _91tab_93mnd1IKlWSPMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/app/index.vue")
  },
  {
    name: "app-l-jwt",
    path: "/app/l/:jwt()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "auth-slug",
    path: "/medlem/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "auth-callback",
    path: "/medlem/callback",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue")
  },
  {
    name: "blackweek",
    path: "/blackweek",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue")
  },
  {
    name: "blog-slug",
    path: "/blogg/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blogg",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue")
  },
  {
    name: "book-tripid-step",
    path: "/bestill/:tripid()/:step()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "bookcall",
    path: "/boka-samtal",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue")
  },
  {
    name: "bookflight-tripid",
    path: "/bookflight/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "booking-confirmation-id",
    path: "/booking-confirmation/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "booking-finish-ocr",
    path: "/booking-finish/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "bookingfaq-ocr",
    path: "/boknings-faq/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "byebyeie",
    path: "/byebyeie",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/byebyeie.vue")
  },
  {
    name: "calendar",
    path: "/kalender",
    meta: indexY9TIYXoorwMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue")
  },
  {
    name: "calendar-lastminute",
    path: "/kalender/restplasser",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue")
  },
  {
    name: "campaign-name",
    path: "/kampanje/:name()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue")
  },
  {
    name: "campaign",
    path: "/kampanje",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue")
  },
  {
    name: "catalogue",
    path: "/katalog",
    meta: catalogueSz9rf6kcZvMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue")
  },
  {
    name: "category-slug",
    path: "/kategori/:slug()",
    meta: _91slug_93gGCPsybSEgMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "competition-slug",
    path: "/konkurranse/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "complaint",
    path: "/reklamasjon",
    meta: complaintTTXdxlbZaAMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/complaint.vue")
  },
  {
    name: "destination-slug-tab",
    path: "/destination/:slug()/:tab()",
    meta: _91tab_93XtqzH90rnhMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "dinbokning-aktuell",
    path: "/dinbokning-aktuell",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue")
  },
  {
    name: "event-slug",
    path: "/arrangement/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue")
  },
  {
    name: "event",
    path: "/arrangement",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/faq.vue")
  },
  {
    name: "fn-id",
    path: "/fn/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "giftcard-id",
    path: "/gavekort/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue")
  },
  {
    name: "giftcard",
    path: "/gavekort",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/giftcard/index.vue")
  },
  {
    name: "hotels-name",
    path: "/hoteller/:name()",
    meta: _91name_93vFeNP8EymdMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/hotels/[name].vue")
  },
  {
    name: "hotels",
    path: "/hoteller",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/hotels/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug()",
    meta: _91slug_930dB0hjD0PdMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "info-about-tab",
    path: "/info/om/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info-connections-tab",
    path: "/info/anslutning/:tab()",
    meta: _91tab_937bTDmfCT02Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-grouptravel",
    path: "/info/gruppereiser",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue")
  },
  {
    name: "info-lectures-tab",
    path: "/info/forelesninger/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-reviews",
    path: "/info/reviews",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/reviews.vue")
  },
  {
    name: "info-solo-tab",
    path: "/info/solo/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue")
  },
  {
    name: "lastminute",
    path: "/restplasser-tilbud",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue")
  },
  {
    name: "map",
    path: "/kart",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue")
  },
  {
    name: "mytrip-tab",
    path: "/dinreise/:tab()",
    meta: _91tab_93eJkMdOJ96PMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "mytrip-dinbokning",
    path: "/mytrip/dinbokning",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue")
  },
  {
    name: "newsletter",
    path: "/nyhetsbrev",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/newsletter.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/offline.vue")
  },
  {
    name: "omdome-id",
    path: "/omdome/:id()",
    meta: _91id_93pOzk630tR1Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/payment/failed.vue")
  },
  {
    name: "review",
    path: "/evaluere-reisen",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/review/index.vue")
  },
  {
    name: "satisfactionstatus-triptypeid-paxid",
    path: "/tilfredshet-status/:triptypeid()/:paxid()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "search",
    path: "/sok",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/search.vue")
  },
  {
    name: "shipinfo-name",
    path: "/cruiseskip/:name()",
    meta: _91name_934UzcbxHbGAMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "titinerary-slug",
    path: "/reiseplan/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "tourleader-id-slug",
    path: "/reiseleder/:id()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "tourleader",
    path: "/reiseleder",
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/tourleader/index.vue")
  },
  {
    name: "verification-done",
    path: "/verification-done",
    meta: verification_45done4hNQU4E4vTMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-05-28-1232/rtg-monorepo/src/layers/web/pages/verification-done.vue")
  }
]